import { Component } from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon, RefreshCw } from "lucide-react";

/**
 * ErrorBoundary — capture les erreurs React (JS runtime) et affiche un
 * écran "erreur 500" propre au lieu d'un écran blanc.
 */
export class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary] caught", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div data-testid="page-500" className="min-h-[80vh] bg-white flex items-center py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
          <div className="overline mb-4 text-center"><span className="red-dot" />Erreur 500</div>
          <h1 className="font-display text-[10rem] sm:text-[14rem] lg:text-[18rem] font-bold leading-[0.85] tracking-tighter text-center">
            500
          </h1>
          <div className="text-center mt-6">
            <h2 className="font-display text-2xl md:text-3xl font-bold tracking-wide uppercase">
              Une erreur est survenue
            </h2>
            <div className="w-16 h-0.5 bg-[#E60000] mx-auto mt-6 mb-8" />
            <p className="text-gray-600 leading-relaxed max-w-md mx-auto mb-10">
              Un imprévu nous empêche d&apos;afficher cette page. Notre équipe a été notifiée — vous pouvez réessayer ou revenir à l&apos;accueil.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <button
                data-testid="retry-btn"
                onClick={() => window.location.reload()}
                className="inline-flex items-center gap-3 bg-[#E60000] hover:bg-[#B30000] text-white px-8 py-4 text-sm font-semibold tracking-wide uppercase transition-colors"
              >
                <RefreshCw className="w-4 h-4" strokeWidth={1.5} /> Recharger la page
              </button>
              <Link
                to="/"
                data-testid="back-home-btn-500"
                className="inline-flex items-center gap-3 border border-gray-300 hover:border-[#E60000] hover:text-[#E60000] px-8 py-4 text-sm font-semibold tracking-wide uppercase transition-colors"
              >
                <HomeIcon className="w-4 h-4" strokeWidth={1.5} /> Retour à l&apos;accueil
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
